import AdminBulkUploadRoute from '@/features/admin/bulk-upload/components/AdminBulkUploadRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/bulk-upload')({
  component: AdminBulkUploadRoute,
});
